import { render, staticRenderFns } from "./pvRoutineList.vue?vue&type=template&id=d94fe1c0&scoped=true&"
import script from "./pvRoutineList.vue?vue&type=script&lang=js&"
export * from "./pvRoutineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94fe1c0",
  null
  
)

export default component.exports